import { styled as t } from "styled-components";
import { Theme as o } from "../../styles/themes/index.js";
import { CaptionLight as e } from "../../styles/typography/index.js";
import { SmartLink as r } from "../SmartLink/index.js";
const n = t.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
  padding: 0 24px;
`, s = t.li`
  flex: 1 0 auto;
  width: calc(50% - 4px);
  padding: 8px 0;
  white-space: nowrap;
`, d = t(r)`
  ${e}
  color: rgb(${o.colors.Alpha});
  text-decoration: none;
  display: block;
`;
export {
  d as FeaturedStoresLink,
  n as FeaturedStoresList,
  s as FeaturedStoresListItem
};
